<template>
    <div>
        <!-- Modal de Situação da Autorização -->
        <div class="modal fade" id="situacaoAutorizacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Autorização
                            <span class="badge badge-secondary ml-2" v-if="autorizacao && autorizacao.id_solicitacao_autorizacao">
                                #{{ autorizacao ? autorizacao.id_solicitacao_autorizacao : '' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="autorizacao">
                            <div class="alert d-flex justify-content-between mb-3 px-2" :class="'alert-' + autorizacao.autorizacao.status_solicitacao.color">
                                <div>{{ autorizacao.nome_paciente }}</div>
                                <div>{{ autorizacao.autorizacao.status_solicitacao.msg }}</div>
                            </div>

                            <button type="button" class="btn btn-outline-primary mb-3" @click="editar_contatos(autorizacao)" v-if="false">
                                <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                                Ocorrências
                            </button>

                            <table class="table">
                                <tr :class="'table-' + traduzir_status_autorizacao(autorizacao.autorizacao.in_status).color">
                                    <td>{{ autorizacao.procedimento.search }}</td>
                                    <td class="text-right">{{ traduzir_status_autorizacao(autorizacao.autorizacao.in_status).msg }}
                                        <div v-if="autorizacao.autorizacao.st_codigo_autorizacao" class="small text-muted">
                                            <div>Senha: {{ autorizacao.autorizacao.st_codigo_autorizacao }}</div>
                                            <div v-if="autorizacao.autorizacao.dt_valid_termino">Valid.: {{ $util.getFormatDate(autorizacao.autorizacao.dt_valid_termino) }}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="(outro, iox) in autorizacao.autorizacao.js_secundarios" :key="iox"
                                    :class="'table-' + traduzir_status_autorizacao(outro.in_status).color">
                                    <td>{{ outro.search }}</td>
                                    <td class="text-right">
                                        {{ traduzir_status_autorizacao(outro.in_status).msg }}
                                        <div v-if="outro.st_codigo_autorizacao" class="small text-muted">
                                            <div>Senha: {{ outro.st_codigo_autorizacao }}</div>
                                            <div v-if="outro.dt_valid_termino">Valid.: {{ $util.getFormatDate(outro.dt_valid_termino) }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div v-if="autorizacao.autorizacao && autorizacao.autorizacao.contatos && autorizacao.autorizacao.contatos.length">
                                <table class="table table-hover table-sm">
                                    <thead>
                                        <tr>
                                            <th>Ocorrência</th>
                                            <th>Data</th>
                                            <th>Usuário</th>
                                            <th>Observação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(contato, ic) in autorizacao.autorizacao.contatos" :key="ic">
                                            <td>
                                                <span v-if="contato.contato_status" :class="'badge badge-' + contato.contato_status.st_color">
                                                    {{ contato.contato_status.search }}
                                                </span>
                                            </td>
                                            <td>{{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.slice(11,16) }}</td>
                                            <td>
                                                <span v-if="contato.usuario">
                                                    {{ contato.usuario.st_login }}
                                                </span>
                                            </td>
                                            <td>{{ contato.st_observacoes }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" @click="abrir_anexar_arquivo()" v-if="autorizacao && autorizacao.autorizacao && autorizacao.autorizacao.arquivos.length && autorizacao.autorizacao.arquivos.length > 0">
                            <i class="fa fa-paperclip" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :viewonly="true"
                :arquivos="autorizacao.autorizacao.arquivos"
                :parms="{ 
                    model_type: 'solicitacaoAutorizacao', 
                    model_id: autorizacao.id_solicitacao_autorizacao, 
                }" />
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import AzFileUpload from '../../util/AzFileUpload.vue';

export default {
    data() {
        return {
            autorizacao: null,
            acao_anexar: false, 
        }       
    },

    components: {
        AzFileUpload
    },

    methods: { 
        abrir (marcacao) { 
            this.acao_anexar = false; 
            this.autorizacao = null; 

            $('#situacaoAutorizacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: { 
                    id: marcacao.id_solicitacao_autorizacao,
                    para_agendar: true, 
                    contatos: true, 
                },
                loadTo: res => { 
                    this.autorizacao = _.cloneDeep(marcacao);
                    this.autorizacao.autorizacao = res;
                },
            });
        },

        traduzir_status_autorizacao(status) { 
            switch (status) {
                case 0: return { msg: 'Aberto', color: 'primary' };
                case 1: return { msg: 'Autorizado', color: 'success' };
                case 2: return { msg: 'Em análise', color: 'info' };
                case 3: return { msg: 'Negado', color: 'danger' };
                case 4: return { msg: 'Autorizado Parcialmente', color: 'warning' };
                case 5: return { msg: 'Cancelado', color: 'Secondary' };
                case 6: return { msg: 'Enviado', color: 'dark' };
                case 7: return { msg: 'Negado Parcialmente', color: 'danger' };
                case 8: return { msg: 'Cancelado Parcialmente', color: 'secondary' };
                default: return { msg: status, color: 'light' };
            }
        },

        abrir_anexar_arquivo() { 
            this.acao_anexar = true;

            // Ajuste para carregar os arquivos sempre que clicar no botão
            this.carregar_arquivos(true);
            return;
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.autorizacao.id_solicitacao_autorizacao,
                    type: 'solicitacaoAutorizacao',
                }
            })
            .then(res => {
                this.autorizacao.autorizacao.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

    }

}
</script>
